import { render, staticRenderFns } from "./ProductDetailsGs1.vue?vue&type=template&id=d740c458&scoped=true"
import script from "./ProductDetailsGs1.vue?vue&type=script&lang=js"
export * from "./ProductDetailsGs1.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsGs1.vue?vue&type=style&index=0&id=d740c458&prod&lang=sass&scoped=true"
import style1 from "./ProductDetailsGs1.vue?vue&type=style&index=1&id=d740c458&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d740c458",
  null
  
)

export default component.exports